import { hydrateRoot, createRoot } from 'react-dom/client'

import App from './App'
/**
 * When `#cedarjs-app` isn't empty then it's very likely that you're using
 * prerendering. So React attaches event listeners to the existing markup
 * rather than replacing it.
 * https://reactjs.org/docs/react-dom-client.html#hydrateroot
 */
const cedarJsAppElement = document.getElementById('cedarjs-app')

if (!cedarJsAppElement) {
  throw new Error(
    "Could not find an element with ID 'cedarjs-app'. Please ensure it exists in your 'web/src/index.html' file."
  )
}

if (cedarJsAppElement.children?.length > 0) {
  hydrateRoot(cedarJsAppElement, <App />)
} else {
  const root = createRoot(cedarJsAppElement)
  root.render(<App />)
}
